// This icon file is generated automatically.
var PBgColorsOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.97 10.63c.69 0 1.25-.57 1.25-1.26 0-.83-1.25-2.2-1.25-2.2s-1.24 1.37-1.24 2.2c0 .7.56 1.26 1.24 1.26zm-5.89-.69c.11.11.3.11.4 0l4-4a.28.28 0 000-.4l-4-4-.03-.03L4.23.3a.14.14 0 00-.2 0l-.75.75a.14.14 0 000 .2L4.33 2.3 1.08 5.54a.28.28 0 000 .4l4 4zm.2-7l2.8 2.79H2.49l2.8-2.8zm7.84 8.81H.88a.13.13 0 00-.13.13v1.24c0 .07.06.13.13.13h12.24c.07 0 .13-.06.13-.13v-1.24a.13.13 0 00-.13-.13z", "fill-rule": "nonzero" } }] }, "name": "p-bg-colors", "theme": "outlined" };
export default PBgColorsOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PBgColorsOutlined.js
// module id = 3236
// module chunks = 0